export const GALLERY_IMAGE_UPLOAD_REQUEST = "GALLERY_IMAGE_UPLOAD_REQUEST";
export const GALLERY_IMAGE_UPLOAD_SUCCESS = "GALLERY_IMAGE_UPLOAD_SUCCESS";
export const GALLERY_IMAGE_UPLOAD_FAIL = "GALLERY_IMAGE_UPLOAD_FAIL";

export const GALLERY_IMAGE_FETCH_REQUEST = "GALLERY_IMAGE_FETCH_REQUEST";
export const GALLERY_IMAGE_FETCH_SUCCESS = "GALLERY_IMAGE_FETCH_SUCCESS";
export const GALLERY_IMAGE_FETCH_FAIL = "GALLERY_IMAGE_FETCH_FAIL";

export const GALLERY_IMAGE_DELETE_REQUEST = "GALLERY_IMAGE_DELETE_REQUEST";
export const GALLERY_IMAGE_DELETE_SUCCESS = "GALLERY_IMAGE_DELETE_SUCCESS";
export const GALLERY_IMAGE_DELETE_FAIL = "GALLERY_IMAGE_DELETE_FAIL";
